import React, { useEffect, useState } from 'react'
import UploadFilesModal from '../components/Integrations/UploadFilesModal'
import styles from '../styles/Integrations.module.css'

import IntegrationContextProvider from '../store/integration-context'
import Zendesk from '../components/Zendesk/Zendesk'
import ZendeskContextProvider from '../store/zendesk-context'


const Integrations = () => {
    return (
        <IntegrationContextProvider>
            <div className='container bodyContainer'>
                <div className="d-flex justify-content-between align-items-center page-header ">
                    <h1 className="page-heading">Integrations</h1>
                    {/* <button type="button" className={`btn btn-primary ${styles.addFilesButton}`} data-bs-toggle="modal" data-bs-target="#uploadFilesModal">
                        Add Files Manually
                    </button> */}
                </div>
                {/* Zendesk Integration */}
                <ZendeskContextProvider>
                    <Zendesk />
                </ZendeskContextProvider>
            </div>
            
            {/* <UploadFilesModal /> */}

        </IntegrationContextProvider>
    )
}

export default Integrations